import type { SVGProps } from 'react';

const SvgLinearAttribution = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="linear-attribution"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#242121"
      d="M24.59 23.56v-1.62h.36c1.62 0 2.94-1.32 2.94-3S26.57 16 24.95 16h-.36v-2.94h.47c.74 0 1.33.6 1.33 1.33v.37h1.5v-.37c0-1.56-1.27-2.83-2.83-2.83h-.47V9.94h-1.5v1.62h-.36c-1.62 0-2.94 1.32-2.94 3s1.32 2.94 2.94 2.94h.36v2.94h-.47c-.74 0-1.33-.6-1.33-1.33h-1.5c0 1.56 1.27 2.83 2.83 2.83h.47v1.62zM22.73 16c-.8 0-1.44-.65-1.44-1.5 0-.79.65-1.44 1.44-1.44h.36V16zm1.86 1.5h.36c.79 0 1.44.65 1.44 1.5 0 .79-.65 1.44-1.44 1.44h-.36z"
    />
    <path
      fill="#242121"
      d="M3.69 31.27h18.27c1.52 0 2.75-1.23 2.75-2.75v-1.77h-1.5v1.77c0 .69-.56 1.25-1.25 1.25H3.69c-.69 0-1.25-.56-1.25-1.25V3.48c0-.69.56-1.25 1.25-1.25h18.27c.69 0 1.25.56 1.25 1.25v3.58h1.5V3.48c0-1.52-1.23-2.75-2.75-2.75H3.69C2.17.73.94 1.97.94 3.48v25.04c0 1.52 1.23 2.75 2.75 2.75"
    />
    <path
      fill="#242121"
      d="M5.65 6.99h1.5v17.59h-1.5zM9.73 6.99h1.5v17.59h-1.5zM13.82 6.99h1.5v17.64h-1.5z"
    />
  </svg>
);

export default SvgLinearAttribution;
